<template>
  <div class="info-note-tooltip" v-tooltip="text">?</div>
</template>

<script>
export default {
  name: 'InfoNoteTooltip',
  props: ['text']
}
</script>

<style lang="stylus" scoped>
.info-note-tooltip
  m-font-size(8,9)
  font-weight $fw-bold
  color #ffffff
  background #222
  height 10px
  width 10px
  border-radius 50%
  display inline-block
  text-align center
  cursor pointer
</style>>
